export default __webpack_public_path__ + "static/media/brian_spain.45e6f443.jpg";